module.exports = __webpack_public_path__ + "static/media/IMG_0835.b17747f7.jpg";